import type { User } from "@open-booking/shared";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PersistConfig } from "redux-persist";
import { secureStorage } from "@/src/common/services/storage.service";

interface AuthState {
	user: User | null;
	isAuthenticated: boolean;
	csrfToken: string | null;
}

const initialState: AuthState = {
	user: null,
	isAuthenticated: false,
	csrfToken: null,
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setUser: (state, { payload }: PayloadAction<User>) => {
			state.user = payload;
			state.isAuthenticated = true;
		},
		setCsrfToken: (state, { payload }: PayloadAction<string | null>) => {
			state.csrfToken = payload;
		},
		setAuthSession: (state, { payload }: PayloadAction<{ user: User; csrfToken: string }>) => {
			state.user = payload.user;
			state.isAuthenticated = true;
			state.csrfToken = payload.csrfToken;
		},
		logOut: () => {
			return { ...initialState };
		},
	},
});

export const { setUser, setCsrfToken, setAuthSession, logOut } = authSlice.actions;

export const authPersistConfig: PersistConfig<AuthState> = {
	key: "auth",
	storage: secureStorage,
	whitelist: ["user", "isAuthenticated"],
};
